import React from 'react';
import { renderTimes, Skeleton } from '@shared/components/Skeleton';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const SkeletonRegistryGuideTitle = () => {
  return (
    <Flex justifyContent="space-between">
      <Skeleton width={pxToRem(172)} height={pxToRem(18)} marginRight={4} />
      <Skeleton width={pxToRem(33)} height={pxToRem(18)} />
    </Flex>
  );
};

export const SkeletonProgressSummary = () => {
  return (
    <Flex flexDirection="column">
      <Skeleton height={pxToRem(21)} marginBottom={5} />
      <Skeleton height={pxToRem(16)} marginBottom={5} />
      <Flex justifyContent="space-between">
        <Skeleton width={pxToRem(172)} height={pxToRem(18)} />
        <Skeleton width={pxToRem(33)} height={pxToRem(18)} />
      </Flex>
    </Flex>
  );
};

export const SkeletonProgressSummaryAndTitle = () => {
  return (
    <Flex flexDirection="column">
      <Skeleton height={pxToRem(25)} width={pxToRem(245)} marginBottom={6} />
      <Skeleton height={pxToRem(21)} marginBottom={5} />
      <Skeleton height={pxToRem(16)} marginBottom={5} />
      <Flex justifyContent="space-between">
        <Skeleton width={pxToRem(172)} height={pxToRem(18)} />
        <Skeleton width={pxToRem(33)} height={pxToRem(18)} />
      </Flex>
    </Flex>
  );
};

export const SkeletonPriceRanges = ({ wrapItems }: { wrapItems: boolean }) => {
  return (
    <Flex flexDirection="column">
      <Skeleton height={pxToRem(26)} width={pxToRem(188)} marginBottom={wrapItems ? 6 : 5} alignSelf={wrapItems ? 'center' : 'flex-start'} />
      <Flex justifyContent="space-evenly" flexWrap={wrapItems ? 'wrap' : 'nowrap'}>
        {renderTimes(4, _ => (
          <Flex key={_} flexDirection="column" alignItems="center" flex={wrapItems ? { _: '0 0 50%', sm2: 'none', md: '0 0 50%' } : 'none'} marginBottom={wrapItems ? 5 : 0}>
            <Skeleton height={pxToRem(48)} width={pxToRem(46)} marginBottom={2} />
            <Skeleton height={pxToRem(21)} width={pxToRem(85)} marginBottom={1} />
            <Skeleton height={pxToRem(18)} width={pxToRem(112)} />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
